// components/router/RequireStaff.tsx
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useStateContext } from "../../contexts/ContextProvider";
import Loader from "../dataDisplay/Loader";
import { isVoluntaryLogout } from "../../helpers/voluntaryLogout";

export default function RequireStaff() {
    const { token, user, isUserLoading } = useStateContext();
    const { pathname, search } = useLocation();

    // Session absente : la page demandée (lien profond, ex. /email-templates/ai/new?type=…) est rouverte après la
    // connexion. Pas après une déconnexion volontaire : on ne renvoie pas quelqu'un là où il a choisi de partir.
    if (!token) {
        return <Navigate to={isVoluntaryLogout() ? "/login" : `/login?redirect=${encodeURIComponent(pathname + search)}`} replace />;
    }

    if (isUserLoading) {
        return <Loader message="chargement" useNeutralLoader={true} />;
    }

    // si l'utilisateur a un customer_id, on l'envoie vers l'espace client
    if (user?.customer_id) {
        return <Navigate to="/customer-space" replace />;
    }

    return <Outlet />;
}
